import { Directive, effect, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[upuAutoFocus]',
})
export class AutoFocusDirective {
  private readonly eleRef = inject<ElementRef<HTMLElement>>(
    ElementRef<HTMLElement>,
  );

  protected focusEffect = effect(() => {
    this.eleRef.nativeElement.focus({ preventScroll: true });
  });
}
